import {
  toResponseError,
  type DashboardListInput,
  type DashboardRemoveInput,
  type DashboardRemoveSuccess,
} from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useDashboardCache } from './cache'

export function useRemoveDashboard(input?: DashboardListInput): RemoveHookResponse<DashboardRemoveInput> {
  const cache = useDashboardCache(input)
  const mutation = useTantalimMutation<DashboardRemoveInput, DashboardRemoveSuccess>({
    url: '/report/dashboard/remove',
  })

  async function remove(input: DashboardRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.removeItem(input.dashboardId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
